import { render, staticRenderFns } from "./ProfitValues.vue?vue&type=template&id=037b301a&scoped=true&"
import script from "./ProfitValues.vue?vue&type=script&lang=ts&"
export * from "./ProfitValues.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitValues.vue?vue&type=style&index=0&id=037b301a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b301a",
  null
  
)

export default component.exports